import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import AttachmentWorkspace from './AttachmentWorkspace';

const Attachments = () => {
  const { t } = useTranslation();
  const { isDark } = useTheme();

  return (
    <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 ${isDark ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className="mb-6">
        <h1 className={`text-3xl font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>
          {t('attachments.title')}
        </h1>
        <p className={isDark ? 'text-gray-300' : 'text-gray-600'}>
          {t('attachments.description')}
        </p>
      </div>
      <AttachmentWorkspace mode="global" />
    </div>
  );
};

export default Attachments; 